// extracted by mini-css-extract-plugin
export default {"cardDescription":"cardDescription_cardDescription__Qv-k1"};